/* eslint-disable import/no-cycle */
import {computed, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {OperationState} from '../models/operationState';

export class OperationStateStore extends EntityStore {
  operationStates = [];

  constructor(rootStore) {
    super(rootStore, 'operationStates', Api.operationStates, OperationState);
  }

  get initialStates() {
    return this.operationStates.filter((state) => state.isInitial || state.isFinal);
  }
}

decorate(OperationStateStore, {
  operationStates: observable,
  initialStates: computed,
});
